import React, { useState } from 'react';

import { check } from '@/assets/icons';
import { SettingsList, SettingsListItems } from '@/components/shared/SettingCard';
import { SingleActionLayout } from '@/components/shared/SingleActionLayout/SingleActionLayout';
import { DefaultKeys } from '@/config/constants';
import { SvgIcon } from '@material-ui/core';

import { IPropsSongModalDisplay } from '../SongModalPanel';
import styles from './RecordedKey.module.scss';

export const RecordedKey: React.FC<IPropsSongModalDisplay> = ({
	openedSong,
	popDisplayState,
	updateTeamSong,
}) => {
	const { recordedKey } = openedSong;
	const [touched, setTouched] = useState(false);
	const [selectedKey, setSelectedKey] = useState<string | null | undefined>(
		recordedKey,
	);

	const keyItems: SettingsListItems = DefaultKeys.map((key) => ({
		type: 'setting' as const,
		title: key,
		trailingComponent: key === selectedKey ? (
			<div className={styles['key-check--selected']}>
				<SvgIcon component={check} />
			</div>
		) : undefined,
		onClick: () => {
			setTouched(true);
			setSelectedKey(key);
		},
	}));

	return (
		<SingleActionLayout
			noPadding
			actionDisabled={!touched}
			actionLabel="Save Recorded Key"
			onActionClick={() => {
				updateTeamSong({ recordedKey: selectedKey });
				popDisplayState();
			}}
		>
			<div className={styles['list-wrapper']}>
				<SettingsList items={keyItems} />
			</div>
		</SingleActionLayout>
	);
};
